













































import { Component, Prop, PropSync, Ref, Vue, Watch } from 'vue-property-decorator';
import CurrencyDisplay from '@/components/misc/CurrencyDisplay.vue'
import { CalendarRatePlanAccomodationUnitTypeView } from './CalendarTypes';
import { Getter } from 'vuex-class';

@Component({
  components: {
    CurrencyDisplay
  }
})
export default class RatePlanSelectModal extends Vue {
  @PropSync('open') internalOpen?: boolean;
  @Prop() availableRatePlans?: CalendarRatePlanAccomodationUnitTypeView[];
  @Prop() showApllyToAllCheckbox?: boolean;

  @Getter("appParams/showPAXSuffixInRatePlanName")
  showPAXSuffixInRatePlanName?: boolean;
  @Getter("appParams/showLOSSuffixInRatePlanName")
  showLOSSuffixInRatePlanName?: boolean;
  
  @Ref('form') form?: {
    resetValidation: () => void;
    validate: () => boolean;
  };

  @Watch('$route') 
  routeChanged() {
    this.internalOpen = false;
  }

  @Watch('open') 
  onOpenChanged() {
    this.form?.resetValidation();
    this.ratePlansAccomodationUnitTypeId = 0;
  }

  required(value: string) {
    return value ? true : this.$t("Validation.Required")
  }

  ratePlansAccomodationUnitTypeId = 0;
  updateOtherUnits = false;

  submit() {
    this.internalOpen = false;

    this.$emit("ratePlanSelected", { ratePlansAccomodationUnitTypeId: this.ratePlansAccomodationUnitTypeId , updateOtherUnits: this.updateOtherUnits, autoPriceRecalculation: false });
  }

  getRateName(rate: any) {
    let paxSuffix = "";
    let losSuffix = "";
    if (this.showPAXSuffixInRatePlanName) {
      paxSuffix =
      rate.minPersons === rate.maxPersons
        ? `, ${rate.minPersons} pax`
        : `, ${rate.minPersons}-${rate.maxPersons} pax`;
    }
    if (this.showLOSSuffixInRatePlanName) {
      losSuffix =
        rate.maxStay === 0
          ? `, ${rate.minStay}+ LOS`
          : rate.minStay === rate.maxStay
          ? `, ${rate.minStay} LOS`
          : `, ${rate.minStay}-${rate.maxStay} LOS`;
    }
    return `${rate.name}${paxSuffix}${losSuffix}`;
  }
  
}
